import React from 'react';
import { PropTypes } from 'prop-types';

import { SectionContent } from '../section-content/SectionContent';
import styles from './MainSectionContent.css';

const mainSectionTemplate = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
};

const IPropTypes = {
  title: PropTypes.string.isRequired,
  mainSectionInfo: PropTypes.arrayOf(PropTypes.shape(mainSectionTemplate)).isRequired,
};

const MainSectionContent = props => (
  <div>
    <h1 className={styles.mainSectionTitle}> {props.title} </h1>
    {
      props.mainSectionInfo.map(section => (
        <SectionContent
          key={section.title}
          title={section.title}
          sectionInfo={section.items}
        />
      ))
    }
  </div>
);

MainSectionContent.propTypes = IPropTypes;

export { MainSectionContent };



// WEBPACK FOOTER //
// ./src/pages/information/help/main-section-content/MainSectionContent.jsx